import type { BookTimelineLayout } from "../../../book/BookLayout";
import type { ActiveLocationGroup } from "@/lib/timeline/location";
import type { BoardModelDebugMeasureContext } from "../measurable";
import { emptyDebugFrameIdSets } from "../register";
import { applyActiveLocationGroupDebug } from "../ActiveLocationGroup/apply";
import {
  ensureBoardModelDebugFrame,
  hideStaleBoardModelDebugFrames,
} from "../host";
import {
  ensureBoardModelDebugLabelHost,
  hideStaleBoardModelDebugLabels,
} from "../labelHost";

const HOST = "[data-location-cast-debug-host]";

function labelsRoot(locationsRoot: HTMLElement): HTMLElement | null {
  return locationsRoot.parentElement?.querySelector<HTMLElement>(
    ".timeline-labels",
  ) ?? null;
}

function worldRoot(locationsRoot: HTMLElement): HTMLElement | null {
  return locationsRoot.parentElement;
}

export function updateLocationCastDebugFrames(
  locationsRoot: HTMLElement,
  layout: BookTimelineLayout,
  playheadMs: number,
  enabled: boolean,
  groups: readonly ActiveLocationGroup[],
): void {
  const host = locationsRoot.querySelector<HTMLElement>(HOST);
  const world = worldRoot(locationsRoot);
  const labels = labelsRoot(locationsRoot);
  if (world === null || labels === null) {
    return;
  }
  const models = [
    "Location",
    "LocationGroup",
    "LocationPrimary",
    "LocationSecondary",
  ] as const;
  const labelHost = ensureBoardModelDebugLabelHost(world);
  if (!enabled) {
    if (host !== null) {
      for (const model of models) {
        hideStaleBoardModelDebugFrames(host, model, new Set());
      }
    }
    for (const model of models) {
      hideStaleBoardModelDebugLabels(labelHost, model, new Set());
    }
    return;
  }
  if (host === null) {
    return;
  }
  const context: BoardModelDebugMeasureContext = {
    world,
    labelHost,
    labelsRoot: labels,
    locationsRoot,
    layout,
    playheadMs,
  };
  const idSets = emptyDebugFrameIdSets();
  applyActiveLocationGroupDebug(
    host,
    context,
    groups,
    idSets,
    ensureBoardModelDebugFrame,
  );
  hideStaleBoardModelDebugFrames(host, "Location", idSets.location);
  hideStaleBoardModelDebugFrames(host, "LocationGroup", idSets.locationGroup);
  hideStaleBoardModelDebugFrames(host, "LocationPrimary", idSets.primary);
  hideStaleBoardModelDebugFrames(host, "LocationSecondary", idSets.secondary);
  hideStaleBoardModelDebugLabels(labelHost, "Location", idSets.location);
  hideStaleBoardModelDebugLabels(labelHost, "LocationGroup", idSets.locationGroup);
  hideStaleBoardModelDebugLabels(labelHost, "LocationPrimary", idSets.primary);
  hideStaleBoardModelDebugLabels(labelHost, "LocationSecondary", idSets.secondary);
}
